/**
 * Fallback handler: mic-unavailable
 *
 * Fires when getUserMedia rejects for a reason that is not a permission
 * refusal — NotFoundError (no capture device), NotReadableError (the OS or
 * another app is holding it), OverconstrainedError, AbortError.
 *
 * This kind exists because the alternative was routing those into
 * `mic-permission-denied`, whose copy tells the visitor to grant permission
 * in browser settings. Someone whose mic is held by a video call would go
 * to settings, find permission already granted, and learn nothing. On a work
 * laptop with a meeting client running, that is a likely path, not an
 * exotic one.
 */

import type { FallbackBanner } from "@/voice/types";

export function makeMicUnavailableBanner(onRetry: () => void): FallbackBanner {
  return {
    kind: "mic-unavailable",
    message:
      "Your microphone could not be opened. It may be in use by another app, or no input device is connected.",
    retryAction: onRetry,
    retryLabel: "Try again",
  };
}
